import { useCallback, useEffect, useRef, useState } from 'react';
import { useFetch } from 'hooks/fetch';
import { getAssetSwitchOrderPreview } from '../actions';
const useSwitchAssetOrderPreview = (assetId, toAssetId, quantity, tradingAccountId) => {
    const [order, setOrder] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [fetch] = useFetch();
    const latestQuantity = useRef(quantity);
    const fetchPreview = useCallback(async () => {
        if (!toAssetId || quantity <= 0 || !tradingAccountId) {
            setOrder(undefined);
            setLoading(false);
            return;
        }
        latestQuantity.current = quantity;
        setLoading(true);
        try {
            const result = await fetch(getAssetSwitchOrderPreview(quantity, assetId, toAssetId, tradingAccountId));
            if (latestQuantity.current === quantity) {
                setOrder(result);
            }
        }
        catch {
            if (latestQuantity.current === quantity) {
                setOrder(undefined);
            }
        }
        finally {
            if (latestQuantity.current === quantity) {
                setLoading(false);
            }
        }
    }, [assetId, toAssetId, quantity, tradingAccountId]);
    useEffect(() => {
        fetchPreview();
    }, [fetchPreview]);
    return [order, loading];
};
export default useSwitchAssetOrderPreview;
